import React, { Component } from "react"
import { getSlide, NUMBER_OF_SLIDES } from "./slides"
import { ITeacherFlashcard } from "./types"

interface Props {
    flashcard: ITeacherFlashcard
    onClose: () => void
}

interface State {
    currentSlideIndex: number
}

export default class VocabPresentation extends Component<Props, State> {
    private slideContentId: string

    constructor(props: Props) {
        super(props)
        this.state = {
            currentSlideIndex: 0,
        }
        this.slideContentId = `slideContent-${Math.random().toString(36).substr(2, 9)}`
    }

    onPrev = () => {
        let {currentSlideIndex} = this.state
        currentSlideIndex--
        currentSlideIndex = currentSlideIndex < 0 ? 0: currentSlideIndex
        this.setState({currentSlideIndex})
    }

    onNext = () => {
        let {currentSlideIndex} = this.state
        currentSlideIndex++
        currentSlideIndex = currentSlideIndex >= NUMBER_OF_SLIDES ? NUMBER_OF_SLIDES-1: currentSlideIndex
        this.setState({currentSlideIndex})
    }

    onClose = () => {
        let {onClose} = this.props
        onClose()
    }

    handleKeyDown = (e: KeyboardEvent) => {
        switch (e.key) {
            case "Escape":
                this.onClose()
                break
            case "ArrowLeft":
                this.onPrev()
                break
            case "ArrowRight":
                this.onNext()
                break
            default:
                break
        }
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown)
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown)
    }

    render() {
        let {currentSlideIndex} = this.state
        let slide = getSlide(currentSlideIndex)

        if (!slide) return null

        let {flashcard, onClose} = this.props
        let {cardFront, subcategory} = flashcard
        let titleLeft = `${subcategory}: <b><i>${cardFront}</i></b>`
        let {titleRight="", component: SlideComponent, } = slide

        return (
            <div className="flashcard-presentation">
                <div className="slideshow-container">
                    <div className="slide-header">
                        <div className="slide-header--left">
                            <div className="title-left fc-h6" dangerouslySetInnerHTML={{ __html: titleLeft }} />
                            <div className="title-right fc-h6"><b>{titleRight}</b></div>
                        </div>
                        <div className="slide-header--right">
                            <button className="presentation-btn" onClick={onClose}>
                                <img
                                    className="modal-icon"
                                    src={`/assets/images/icons/v2/ico-modal-close.svg`}
                                    width="24"
                                    height="24"
                                    alt="Close"
                                />
                                <span className="sr-only">Close Window</span>
                            </button>
                        </div>
                    </div>

                    <div className="slide-content" id={this.slideContentId}>
                        <SlideComponent flashcard={flashcard} />
                    </div>

                    <div className="slideshow-controls">
                        {currentSlideIndex > 0 && (
                            <button
                                    className="prev"
                                    onClick={this.onPrev}
                                    aria-label="Previous Slide"
                                    aria-controls={this.slideContentId}
                                >
                                <div className="caret-svg" style={{ rotate: `-90deg` }}>
                                    <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="m18 15-6-6-6 6" />
                                    </svg>
                                </div>
                            </button>
                        )}

                        {currentSlideIndex === NUMBER_OF_SLIDES - 1 && (
                            <div className="controls-msg">
                                <p className="fc-p"><b>• TURN AND TALK ABOUT THE WORD •</b></p>
                            </div>
                        )}

                        {currentSlideIndex < NUMBER_OF_SLIDES - 1 && (
                            <button
                                    className="next"
                                    onClick={this.onNext}
                                    aria-label="Next Slide"
                                    aria-controls={this.slideContentId}
                                >
                                <div className="caret-svg" style={{ rotate: `90deg` }}>
                                    <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="m18 15-6-6-6 6" />
                                    </svg>
                                </div>
                            </button>
                        )}
                    </div>

                </div>
            </div>
        )
    }
}
